/**
 * Environment Configuration
 *
 * Centralized access to environment variables with type safety
 */

export const env = {
	// Target environment
	TARGET_ENV: import.meta.env.VITE_TARGET_ENV || "q5",

	// API Configuration
	API_URL:
		import.meta.env.VITE_RAMPS_API_URL || "https://q5ramps.aws.moneygram.com",
	API_TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
	API_RETRY_ATTEMPTS: Number(import.meta.env.VITE_API_RETRY_ATTEMPTS) || 3,

	// Third-party API Keys
	GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
	POSTHOG_API_KEY: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
	POSTHOG_API_HOST: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
	SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
	SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT || "development",

	// Environment checks
	isDevelopment: import.meta.env.MODE === "development",
	isProduction: import.meta.env.MODE === "production",

	// Feature flags
	ENABLE_MANUAL_KYC_INPUTS:
		import.meta.env.VITE_ENABLE_MANUAL_KYC_INPUTS !== "false", // Default to true
	MOCK_KYC_RESPONSE: import.meta.env.VITE_MOCK_KYC_RESPONSE === "true", // Default to false

	// Validation helper
	validate() {
		const missing: string[] = [];

		// Optional in all environments - will log warning but not throw
		if (!this.GOOGLE_MAPS_API_KEY) missing.push("VITE_GOOGLE_MAPS_API_KEY");
		if (!this.POSTHOG_API_KEY) missing.push("VITE_PUBLIC_POSTHOG_KEY");
		if (!this.POSTHOG_API_HOST) missing.push("VITE_PUBLIC_POSTHOG_HOST");

		// Required only in production
		if (!this.SENTRY_DSN && this.isProduction) missing.push("VITE_SENTRY_DSN");

		if (missing.length > 0) {
			console.warn("⚠️  Missing environment variables:", missing.join(", "));
			// Don't throw error - these are optional in all environments
			// Services will gracefully handle missing keys
		}

		return missing.length === 0;
	},
} as const;

// Validate environment on module load
if (typeof window !== "undefined") {
	env.validate();
}
